export default{
    changePersonalInfo(state,str){
      state.personalInfo = str;
      if (state.personalInfo.cardType == ''){
        state.personalInfo.cardType = 'driverLicense';
      };
    },
    changePersonalInfo2(state,str){
      state.personalInfo2 = str;
    },
    SET_SSN: (state,str) =>{
      state.personalInfo.SSN = str;
    },
    BTN_LOADING:(state,str)=> {
      state.isBtnLoading = str;
    },
    changeAssets(state,str){
      state.assetsObj = str;
    },
    withdrawTotail(state,str){
      state.withdraw = str;
    },
    RECURRING_TYPE:(state,str)=> {
      state.recurringType = str;
    },
    RECURRING_OBJ:(state,str)=>{
      state.recurringObj = str;
    },
    SET_PRICE:(state,str)=>{
      state.priceObj = str;
    },
    set_security(state,val) {
      state.security = val
    },
    set_loginEmail(state,val) {
      state.login_email = val
    }
  }


// WEBPACK FOOTER //
// ./src/store/mutations.js